import React, { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const BobChatWidget = () => {
    const { getAssetUrl } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();

    // Verstecke den schwebenden Button, wenn wir ohnehin schon auf der Bob-Seite sind
    if (location.pathname === '/ai-agent') {
        return null;
    }

    return (
        <div className="fixed bottom-6 right-6 z-[999999] font-sans flex flex-col items-end">
            {/* FLOATING ACTION BUTTON - Navigiert zur KI-Agent Seite */}
            <button
                onClick={() => navigate('/ai-agent')}
                className="w-16 h-16 rounded-full bg-gradient-to-tr from-primary to-secondary text-white shadow-[0_8px_24px_rgba(0,0,0,0.3)] hover:scale-110 active:scale-95 transition-all duration-300 flex items-center justify-center border-2 border-white/60 relative group"
                title="Bob (KI-Agent) öffnen"
            >
                {/* Unterer Teil des Bildes (abgeschnitten durch den runden Button) */}
                <div className="absolute inset-0 rounded-full overflow-hidden">
                    <img
                        src={getAssetUrl('Bob_start.png')}
                        alt="Bob Launcher Base"
                        className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-[140%] max-w-none h-auto object-cover transition-transform duration-300 group-hover:scale-105 origin-bottom"
                    />
                </div>
                {/* Oberer Teil des Bildes (ragt über den Button hinaus) */}
                <div className="absolute inset-0 rounded-full" style={{ clipPath: 'inset(-100% -100% 50% -100%)' }}>
                    <img
                        src={getAssetUrl('Bob_start.png')}
                        alt="Bob Launcher Top"
                        className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-[140%] max-w-none h-auto object-cover transition-transform duration-300 group-hover:scale-105 origin-bottom"
                        onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.parentNode.innerHTML = '<span className="text-2xl relative z-10 flex items-center justify-center h-full w-full">⚜️</span>';
                        }}
                    />
                </div>
            </button>
        </div>
    );
};

export default BobChatWidget;
